import axiosInstance from "../instance/AxiosInstance";
export const bookingViewEffect = async (bookingId) => {
  try {
    const response = await axiosInstance.get(
      `/bookservice/getbookingservice?booking_id=${bookingId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Booking";
  }
};
export const bookingViewAllEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/bookservice/list?pageNo=${payload.pageNo}&pagesize=${payload.pagesize}&pagination_required=true&type=${payload.type}&booked_type=${payload.booked_type}&currentDate=${payload.currentDate}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Bookings";
  }
};

export const fetchAllBookingsEffect = async (booked_type, type = "all") => {
  try {
    const response = await axiosInstance.get(
      `/bookservice/list?pagination_required=false`,
      {
        params: {
          booked_type: booked_type,
          type: type
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch All Bookings";
  }
};
export const fetchCustomerBookingsEffect = async (
  customer_id,
  pageNo,
  pagesize,
  type,
  currentDate,
  vendor_id,
  booked_type
) => {
  try {
    const response = await axiosInstance.get(
      `/bookservice/bookinggetbycustomer`,
      {
        params: {
          pagination_required: true,
          pageNo,
          pagesize,
          customer_id: customer_id,
          type,
          vendor_id,
          currentDate,
          booked_type
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch customer bookings";
  }
};
export const bookingAddEffect = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/bookservice/bookservice`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Add Booking";
  }
};
export const instantBookingAddEffect = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/bookservice/instantbookservice`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.errorFields || "Failed to Add Booking";
  }
};
// Edit instant booking
export const bookingEditEffect = async (payload) => {
  console.log("EDIT PAYLOAD", payload);
  try {
    const response = await axiosInstance.put(
      `/bookservice/updatebooking/${payload?.bookingId}`,
      payload?.updatedData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.errorFields || "Failed to Add Booking";
  }
};
export const instantBookingTokenEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/auth/instanttoken/${payload}`,
      payload
    );
    return response?.data;
  } catch (error) {
    throw error.response?.data?.errorFields || "Failed to Add Booking";
  }
};

export const bookingDeleteEffect = async (payload) => {
  console.log("payload", payload);
  try {
    const response = await axiosInstance.put(
      `/bookservice/cancelbooking/${payload?.payload?.bookingId}`,
      payload?.payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Delete Booking";
  }
};
export const fetchServiceTypeEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/services/getservicetype?service_type=${payload.service_type}&airport_type=${payload.airport_type}&airport_id=${payload.airport_id}`
    );

    return response;
  } catch (error) {
    throw error.response?.data?.message;
  }
};
export const fetchTransitServiceTypeEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/services/gettransitservicetype?transit_type=${payload.transit_type}&service_type=${payload.service_type}&airport_id=${payload.airport_id}`
    );
    return response;
  } catch (error) {
    throw error.response?.data?.message;
  }
};
export const updateBookingDiscountStatusAPI = async (payload) => {
  const response = await axiosInstance.put(
    `/bookservice/bookingserviceapproval/${payload.booking_id}`,
    payload
  );
  return response.data;
};
